import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Popper as MaterialPopper, Fade } from '@mui/material';
import { TooltipArrow } from 'components/ui/icons';

const Popper = ({
  id,
  children,
  popperContent,
  className,
  popperClassName,
  placement,
  preventOverflow,
  flip,
  trigger,
  offset,
  backgroundColor,
  ...props
}) => {
  const timeout = useRef();
  const wrapperRef = useRef();
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    if (props.open) {
      setAnchorEl(wrapperRef.current);
      setOpen(true);
    }
  }, [props.open])

  const togglePopper = (event) => {
    const { currentTarget } = event;
    if (timeout && timeout.current) {
      clearTimeout(timeout.current);
    }
    setAnchorEl(currentTarget);
    setOpen(true);
    timeout.current = setTimeout(() => {
      setAnchorEl(null);
      setOpen(false);
    }, 5000);
  }

  return (
    <div className={className}>
      <span
        ref={wrapperRef}
        aria-describedby={id}
        onClick={trigger === 'click' ? togglePopper : undefined}
        onMouseOver={trigger === 'hover' ? togglePopper : undefined}
      >
        {children}
      </span>
      <MaterialPopper
        id={id}
        open={open}
        anchorEl={anchorEl}
        transition
        placement={placement}
        className={`tooltip-popper ${popperClassName}`}
        style={{
          backgroundColor
        }}
        modifiers={[
          {
            name: 'flip',
            enabled: flip,
            options: {
              altBoundary: true,
              rootBoundary: 'document',
              padding: 8,
            },
          },
          {
            name: 'preventOverflow',
            enabled: preventOverflow,
            options: {
              altAxis: true,
              altBoundary: true,
              tether: true,
              rootBoundary: 'document',
              padding: 8,
            },
          },
          {
            name: 'arrow',
            enabled: true
          },
          {
            name: 'offset',
            options: {
              offset
            },
          },
        ]}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <div>
              {popperContent}
              <div className="popper-arrow" data-popper-arrow><TooltipArrow fill={backgroundColor}/></div>
            </div>
          </Fade>
        )}
      </MaterialPopper>
    </div>
  );
}

Popper.propTypes = {
  id: PropTypes.string.isRequired,
  open: PropTypes.bool,
  popperContent: PropTypes.node.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
  popperClassName: PropTypes.string,
  placement: PropTypes.string,
  preventOverflow: PropTypes.bool,
  flip: PropTypes.bool,
  trigger: PropTypes.string,
  offset: PropTypes.array,
  backgroundColor: PropTypes.string
};

Popper.defaultProps = {
  open: false,
  className: '',
  popperClassName: '',
  placement: 'top',
  preventOverflow: true,
  flip: false,
  trigger: 'click',
  offset: [0, 16],
  children: undefined,
  backgroundColor: '#ffffff'
};

export default Popper;
